<tax-page-header>
  <tax-tabs [tabs]="tabs"></tax-tabs>
</tax-page-header>

<div
  data-qa-block="tariff-type"
  *ngFor="let tariffType of tariffsByTypes$ | async | keyvalue"
  class="tariffs-group"
>
  <div class="tariff-type" data-qa="tariff-type-name">{{ tariffType.value.title | translate }}</div>
  <div class="tariff-list" data-qa="tariff-list">
    <tax-tariff
      *ngFor="let tariff of tariffType.value.tariffs; trackBy: trackById"
      [tariff]="tariff"
    ></tax-tariff>
  </div>
</div>
